import axios from 'axios';
import Constants from '../constants';

export function getTextToSpeechSupportedCulturesQuery() {
	const url = Constants.API_TEXTTOSPEECH_CULTURE_URL;
	return url;
}

export async function getTextToSpeechSupportedCultures(): Promise<string[]> {
	const res = await axios.get(getTextToSpeechSupportedCulturesQuery(), { headers: { Pragma: 'no-cache' } });
	return res.data;
}
